import { render, staticRenderFns } from "./b3.vue?vue&type=template&id=c248b526&scoped=true"
import script from "./b3.vue?vue&type=script&lang=js"
export * from "./b3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c248b526",
  null
  
)

export default component.exports